//=> Import React
import React from "react";

//=> Import plugins
import { Link, graphql, useStaticQuery } from "gatsby";

// Import Swipper =>
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";

//=> Import Styles
import {
  carroussel,
  carrousselTitle,
  link,
  linkName,
  image,
  swipper,
  swipperSlide,
} from "./styles.module.scss";

const CarrousselNewProduct = () => {
  // Requête Products
  const data = useStaticQuery(graphql`
    query {
      allStrapiProduct(sort: { order: DESC, fields: publishedAt }, limit: 10) {
        edges {
          node {
            name
            slug
            image {
              url
              alternativeText
            }
          }
        }
      }
    }
  `);

  const products = data.allStrapiProduct.edges.map((listeProduct) => {


    return {
      name: listeProduct.node.name,
      slug: listeProduct.node.slug,
      image: listeProduct.node.image[0].url,
      alt: listeProduct.node.image[0].alternativeText,
    };
  });

  // Return =>
  return (
    <section className={carroussel}>
      <h4 className={carrousselTitle}>Nos dernières nouveautées:</h4>

      <Swiper
        slidesPerView={"auto"}
        spaceBetween={20}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className={swipper}
      >
        {products.map((product) => (
          <SwiperSlide className={swipperSlide}>
            <Link
              to={`/product/${product.slug}`}
              title={product.name}
              className={link}
              key={product.slug}

            >

              <div
                className={image}
                style={{
                  backgroundImage: `url(${product.image})`,
                  title: `${product.alt}`,
                  ariaLabel: `${product.image}`,

                }}
              />
              <h6 className={linkName}>{product.name}</h6>
            </Link>
          </SwiperSlide>
        ))}

      </Swiper>


    </section>
  );
};

export default CarrousselNewProduct;
